
import { Link2, MonitorSmartphone, Rocket, Headset, ScanFace, Crown } from "lucide-react";
import { TuroAltIntroCopy } from "./TuroAltIntroCopy";
import { InshurClaimCta } from "./InshurClaimCta";
const INSHUR_BENEFITS = {
    eyebrow: "Exclusive INSHUR partner perks",
    heading: (<>
      Inshur customers
      <br />
      get major benefits
    </>),
    headingClassName: "font-heading text-4xl sm:text-5xl lg:text-[52px] font-semibold tracking-tighter leading-[0.95] text-foreground text-balance",
    headingCta: <InshurClaimCta align="start"/>,
    lead: "Period Z built into the checkout? DONE!",
    leadBold: "Everything rental, all in one place.",
    body: "Access essential tools to run your rental business. End-to-end rental management is now included with every INSHUR account, so you can start taking direct bookings efficiently.",
    bodyClassName: "font-medium",
    tagline: "",
    features: [
        {
            icon: Link2,
            title: "Use your own website",
            copy: "Embed link for your website to provide search, inventory, vehicle pages, and checkout system for direct rentals.",
        },
        {
            icon: MonitorSmartphone,
            title: "FREE Direct Rental Website",
            copy: "Don't have a site? Launch a branded, mobile-ready rental website with your fleet and checkout built in.",
        },
        {
            icon: Rocket,
            title: "FREE to start, always",
            copy: "Starter plan is always free to use, then only pay when the vehicle gets rented.",
        },
        {
            icon: Headset,
            title: "FREE VIP Platform Onboarding",
            copy: "VIP onboarding with an industry expert to set up and automate your rental business.",
        },
        {
            icon: ScanFace,
            title: "FREE Driver Verifications  Credits",
            copy: "3 free verification credits for RentID driver verifications.",
        },
        {
            icon: Crown,
            title: "FREE 30 day Pro Plan Trial",
            copy: "Try every Pro feature + Unlimited rentals   30 days free, with no contract or commitments",
        },
    ],
};
export function InshurBenefits() {
    return (<section className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-36 md:pt-24 md:pb-48">
      <TuroAltIntroCopy content={INSHUR_BENEFITS}/>
    </section>);
}
